import React, { useState } from 'react';
import { sorts } from '../../utils';
import AudioRow from '../../components/title/AudioRow';
import Accordion, { AccordionContents } from '../../components/Accordion';
import { ReactComponent as CaratIcon } from '../../svg/carat-down.svg';
import { useSelector } from 'react-redux';

const AdvancedAudioReadOnly = ({ onPlay = () => {}, onPause = () => {}, isPlaying = false, currentTrack = {} }) => {
    const { data } = useSelector((state) => state.title);
    const sections = {
        front_matter: {
            required: false,
            note: 'This is any material preceding the main text. Some common examples are: Title Page, Dedication, Preface, Author Notes, and Introduction.',
            groupName: 'Front Matter',
            multiple: true
        },
        body_matter: {
            required: true,
            note: 'This is the heart of the book. Some common examples are: Chapters, Parts, Epilogues, and Afterwords. Each file must be shorter than 120 minutes.',
            groupName: 'Body Matter',
            multiple: true
        },
        back_matter: {
            required: false,
            note: 'Anything following the main text. Some common examples are: Appendix, Endnotes, Bibliography.',
            groupName: 'Back Matter',
            multiple: true
        },
        retail_sample: {
            required: true,
            note: "Keep it between 1-5 minutes long, and showcase the narration (don't start with music). Avoid explicit language, sexual content, or credits. Customers will use this sample to preview the audiobook before purchasing, so pick an engaging and dynamic part of the book (without spoilers). Note that some retailers may cut their own samples instead of using this one.",
            groupName: 'Retail Sample',
            multiple: false
        }
    };

    const [state] = useState({
        ...Object.keys(sections).reduce((obj, key) => {
            obj[key] = (data.assets || [])
                .filter(
                    (a) =>
                        a.assettype === 'audio' && ((a.group && a.group === key) || (!a.group && key === 'body_matter'))
                )
                .sort((a, b) => sorts.asc(a.groupoffset, b.groupoffset));
            return obj;
        }, {})
    });

    return (
        <div>
            {Object.keys(sections).map((key, i) => {
                let section = sections[key];
                let tracks = state[key] || [];
                // let isPartOutput = false;
                // let currentPartName = '';
                let items = [
                    ...tracks.map((track, i) => {
                        let row = (
                            <AudioRow
                                key={`${track.id}_${i}`}
                                track={track}
                                group={key}
                                onPlay={onPlay}
                                onPause={onPause}
                                isPlaying={isPlaying}
                                currentTrack={currentTrack}
                                readOnly={true}
                                disableTitleEdit={true}
                            />
                        );
                        let content = <>{row}</>;

                        // if (track.section && track.section === currentPartName) {
                        //     content = <div className="afm-track-within-part">{row}</div>;
                        // }

                        // if (track.section && track.section !== currentPartName) {
                        //     content = (
                        //         <>
                        //             <div className="list-group-item chapter-row mb-1 afm-part-name-readonly">
                        //                 <div className="part-title font-italic">{track.section}</div>
                        //             </div>
                        //             <div className="afm-track-within-part">{row}</div>
                        //         </>
                        //     );
                        //     currentPartName = track.section;
                        //     // isPartOutput = true;
                        // }

                        // if (!track.section) {
                        //     currentPartName = '';
                        // }

                        // if (track.section && !isPartOutput) {
                        //     content = <>
                        //         <div className="list-group-item chapter-row mb-1">
                        //             <div className="part-name">{track.section}</div>
                        //         </div>
                        //         <div className="afm-track-within-part">
                        //             {row}
                        //         </div>
                        //     </>;
                        //     currentPartName = track.section;
                        //     isPartOutput = true;
                        // }

                        // if (track.section && track.section !== currentPartName) {
                        //     isPartOutput = false
                        //     currentPartName = track.section;
                        // };

                        return {
                            id: `${key}_track_${i}`,
                            content: content
                        };
                    })
                ];

                return (
                    <Accordion key={`audio${i}`} className="mb-5" defaultOpen={true}>
                        {({ open, handleItemClick }) => (
                            <>
                                <div className="accordion-title at-collapse" onClick={handleItemClick} role="button">
                                    <h2 className="h5">{section.groupName} </h2>
                                    <CaratIcon
                                        width="1em"
                                        height="1em"
                                        stroke="currentColor"
                                        style={{ fontSize: '.75em' }}
                                    />
                                </div>
                                <AccordionContents isOpen={open}>
                                    <div className="accordion-body">
                                        <>
                                            <div className="list-group ui-sortable">
                                                {(items || []).map((item, i) => (
                                                    <div key={i}>{item.content}</div>
                                                ))}

                                                {!tracks.length && (
                                                    <div className="text-default">No tracks in this group.</div>
                                                )}
                                            </div>
                                        </>
                                    </div>
                                </AccordionContents>
                            </>
                        )}
                    </Accordion>
                );
            })}
        </div>
    );
};

export default AdvancedAudioReadOnly;
